// extracted by mini-css-extract-plugin
export var icon = "Tag-module--icon--4bf63";
export var invert = "Tag-module--invert--7ab64";
export var normal = "Tag-module--normal--f0d6f";
export var rerverse = "Tag-module--rerverse--fde9d";
export var reverse = "Tag-module--reverse--4564f";
export var tag = "Tag-module--tag--d660c";